<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>分账明细</h1>
        <p>当前只入账自充积分消耗产生的每级返佣。折扣结算、续费返佣、项目推荐奖、阶梯达标奖和退款红冲还没有自动计算，所以下面这些卡片是 0。</p>
      </div>
    </div>
    <div class="ch-metrics">
      <div class="ch-metric"><div class="k">每级返佣</div><div class="v">¥ {{ yuan(amount) }}</div><div class="s">{{ list.length }} 笔已入账明细</div></div>
      <div class="ch-metric"><div class="k">折扣结算</div><div class="v">¥ 0.00</div><div class="s">尚未计算</div></div>
      <div class="ch-metric"><div class="k">续费 / 项目 / 达标</div><div class="v">¥ 0.00</div><div class="s">尚未计算</div></div>
      <div class="ch-metric"><div class="k">自充积分</div><div class="v">{{ points.toLocaleString() }} 分</div><div class="s">代金券消耗不在这里</div></div>
    </div>
    <div class="ch-panel">
      <div class="ch-filters">
        <select v-model="state">
          <option value="">状态：全部</option>
          <option value="in">已进结算单</option>
          <option value="out">未结算</option>
        </select>
      </div>
      <table class="ch-table">
        <thead><tr><th>发生时间</th><th>级别</th><th>分账类型</th><th>自充积分</th><th>比例</th><th>分账金额</th><th>状态</th></tr></thead>
        <tbody>
          <tr v-for="row in shown" :key="row.id">
            <td>{{ row.createdAt }}</td>
            <td>{{ levelName(row.levelCode) }}</td>
            <td>每级返佣</td>
            <td>{{ Number(row.points || 0).toLocaleString() }}</td>
            <td>{{ row.rate }}</td>
            <td>+ ¥ {{ yuan(row.amount) }}</td>
            <td><span class="ch-tag" :class="row.settlementId ? 'ok' : 'warn'">{{ row.settlementId ? '已入账' : '待随结算发放' }}</span></td>
          </tr>
          <tr v-if="!shown.length"><td colspan="7" class="ch-empty">这个筛选下没有分账记录</td></tr>
        </tbody>
      </table>
      <p class="ch-note" style="margin-top:12px">代金券兑换由 C 端扣费，不计入返佣基数。会员赠送和签到积分也不在这里。</p>
    </div>
  </div>
</template>

<script>
import { getChannelLines } from '@/api/admin'
import { levelName, yuan } from './labels'

export default {
  name: 'PartnerLines',
  data() { return { list: [], state: '' } },
  computed: {
    points() { return this.list.reduce((sum, item) => sum + Number(item.points || 0), 0) },
    amount() { return this.list.reduce((sum, item) => sum + Number(item.amount || 0), 0) },
    shown() {
      if (this.state === 'in') return this.list.filter(item => item.settlementId)
      if (this.state === 'out') return this.list.filter(item => !item.settlementId)
      return this.list
    }
  },
  created() { this.load() },
  methods: {
    levelName, yuan,
    async load() {
      const result = await getChannelLines()
      this.list = result.list || []
    }
  }
}
</script>
